import { ReactNode } from 'react';
const Container = ({ children, containerId }: { children: ReactNode; containerId?: string }) => {
  return (
    <div id={containerId || 'container'}>
      <div className="limitContainer">
        <div className="simpleContainer">{children}</div>
      </div>
    </div>
  );
};

export default Container;
